export default __webpack_public_path__ + "static/media/jokesPreview.2093a515.png";